/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Polyfill for Nodelist
 * from https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
 */
if (window.NodeList && typeof NodeList.prototype.forEach !== "undefined") {
    (NodeList.prototype as any).forEach = Array.prototype.forEach;
}
